import { useCallback, useMemo } from 'react';

import { useProductFiltersCustomFilters } from '@techstyle/react-components';

export const useToggleCollapsibleFilters = ({ initialFilters }) => {
  const { toggleCollapsibleFilterIsOpen } = useProductFiltersCustomFilters();
  const toggleFilters = useMemo(() => {
    const result = [
      ...initialFilters?.aggregations?.map(filter => filter.field),
    ];
    // in some cases, "size" and "product_category_id_list" are not present as aggregations
    if (!result.includes('size')) {
      result.push('size');
    }
    if (!result.includes('product_category_id_list')) {
      result.push('product_category_id_list');
    }
    return result;
  }, [initialFilters]);
  const openFilters = useCallback(() => {
    toggleCollapsibleFilterIsOpen({
      type: 'open_all',
      filterFields: toggleFilters,
    });
  }, [toggleFilters, toggleCollapsibleFilterIsOpen]);

  return openFilters;
};
